export default __webpack_public_path__ + "static/ENT-symbol-bw-eae9961d8acac525921a94210f01edaf.png";